import { shouldPolyfill as shouldPolyfillPluralRules } from "@formatjs/intl-pluralrules/should-polyfill";
import { shouldPolyfill as shouldPolyfillLocale } from "@formatjs/intl-locale/should-polyfill";
// import { shouldPolyfill as shouldPolyfillNumberFormat } from "@formatjs/intl-numberformat/should-polyfill";
import { shouldPolyfill as shouldPolyfillGetCanonicalLocales } from "@formatjs/intl-getcanonicallocales/should-polyfill";
import { getLanguageFromLocale } from "@/lib/config/localeUtils";

interface WindowWithIntl extends Window {
  Intl: unknown;
}

interface MaybePolyfilled {
  polyfilled: boolean;
}

export const intlNumberFormatPolyfill = {
  isNeeded: (): boolean =>
    // Note: this tests for full compatibility, which we don't need.
    // cf https://github.com/formatjs/formatjs/blob/main/packages/intl-numberformat/should-polyfill.ts
    // return shouldPolyfillNumberFormat();

    // FIXME: why does this break on Safari when using the full check?
    typeof Intl === "undefined" || !("NumberFormat" in Intl),

  load: async (locale: string): Promise<void> => {
    if (typeof window.Intl === "undefined") {
      (window as WindowWithIntl).Intl = {};
    }
    if (shouldPolyfillLocale()) {
      await import(
        /* webpackChunkName: "intl-locale-polyfill" */
        "@formatjs/intl-locale/polyfill"
      );
    }
    if (shouldPolyfillGetCanonicalLocales()) {
      await import(
        /* webpackChunkName: "intl-getcanonicallocales-polyfill" */
        "@formatjs/intl-getcanonicallocales/polyfill"
      );
    }
    if (shouldPolyfillPluralRules()) {
      await import(
        /* webpackChunkName: "intl-pluralrules-polyfill" */
        "@formatjs/intl-pluralrules/polyfill"
      );
    }

    await import(
      /* webpackChunkName: "intl-numberformat-polyfill" */
      "@formatjs/intl-numberformat/polyfill"
    );

    const language = getLanguageFromLocale(locale);

    let numberFormatDataPromise;
    let pluralRulesDataPromise;

    if (((Intl.NumberFormat as unknown) as MaybePolyfilled).polyfilled) {
      numberFormatDataPromise = import(
        /* webpackInclude: /\/(?:de|en|es)\.js$/ */
        /* webpackChunkName: "intl-numberformat-data-[request]" */
        `@formatjs/intl-numberformat/locale-data/${language}`
      );
    } else {
      numberFormatDataPromise = Promise.resolve(true);
    }

    if (((Intl.PluralRules as unknown) as MaybePolyfilled).polyfilled) {
      pluralRulesDataPromise = import(
        /* webpackInclude: /\/(?:de|en|es)\.js$/ */
        /* webpackChunkName: "intl-pluralrules-data-[request]" */
        `@formatjs/intl-pluralrules/locale-data/${language}`
      );
    } else {
      pluralRulesDataPromise = Promise.resolve(true);
    }

    await Promise.all([numberFormatDataPromise, pluralRulesDataPromise]);
  },
};
